export default {
  recipeFinished: 'The recipe is no longer running. Your changes cannot be saved.',
  loadStarted: 'A load was started while you were editing. The furnace setpoints can only be changed while no load is running.',
  otherRecipeRunning: 'A different load or recipe is running now. Your changes cannot be saved.',
  passedStepNotSaved: 'Changes to {step} will not be saved because the step has already passed.',
};
